import { ChevronDown, Paperclip } from 'lucide-react';
import { STATUTS, totalPreuves } from './shared';

const CarteIndicateur = ({ ind, onOpen }) => {
  const st = STATUTS[ind.statut];
  const n = totalPreuves(ind.nb_preuves);
  return (
    <button type="button" onClick={() => onOpen(ind.num)}
      className={`group flex items-start gap-3 rounded-xl border-2 p-3 text-left transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md ${st.carte}`}
      data-testid={`qualiopi-indicateur-${ind.num}`}>
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-display text-lg font-bold text-white ${st.pastille}`}>{ind.num}</span>
      <span className="min-w-0 flex-1 space-y-1">
        <span className="block text-sm font-semibold leading-tight text-[#0F172A]">{ind.titre}</span>
        <span className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs">
          <span className={`font-semibold ${st.texte}`} data-testid={`qualiopi-indicateur-${ind.num}-statut`}>{st.label}</span>
          <span className="flex items-center gap-1 text-slate-500"><Paperclip className="h-3 w-3" /> {n} preuve{n > 1 ? 's' : ''}</span>
          <span className={ind.non_conformite === 'majeure' ? 'text-red-600' : 'text-slate-400'}>NC {ind.non_conformite}</span>
        </span>
      </span>
    </button>
  );
};

export const CritereBloc = ({ critere, indicateurs, ouvert, onToggle, onOpen }) => {
  const applicables = indicateurs.filter((i) => i.statut !== 'na');
  const valides = applicables.filter((i) => i.statut === 'vert').length;
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid={`qualiopi-critere-${critere.num}`}>
      <button type="button" onClick={onToggle} aria-expanded={ouvert}
        className="flex w-full items-center gap-4 p-4 sm:p-5 text-left hover:bg-slate-50 transition-colors" data-testid={`qualiopi-critere-${critere.num}-toggle`}>
        <span className="font-display text-3xl font-bold text-slate-200 sm:text-4xl">{critere.num}</span>
        <span className="min-w-0 flex-1 space-y-2">
          <span className="block text-sm font-semibold text-[#0F172A] sm:text-base">{critere.titre}</span>
          <span className="flex flex-wrap items-center gap-1.5">
            {indicateurs.map((i) => <span key={i.num} title={`Indicateur ${i.num} : ${STATUTS[i.statut].label}`} className={`h-2.5 w-6 rounded-full ${STATUTS[i.statut].pastille}`} />)}
            <span className="ml-2 text-xs text-slate-500" data-testid={`qualiopi-critere-${critere.num}-score`}>{valides}/{applicables.length} validés</span>
          </span>
        </span>
        <ChevronDown className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200 ${ouvert ? 'rotate-180' : ''}`} />
      </button>
      {ouvert && (
        <div className="grid gap-3 border-t border-slate-100 bg-slate-50/50 p-4 sm:grid-cols-2 xl:grid-cols-3 animate-in fade-in slide-in-from-top-1 duration-200">
          {indicateurs.map((i) => <CarteIndicateur key={i.num} ind={i} onOpen={onOpen} />)}
        </div>
      )}
    </div>
  );
};
